module.exports = __webpack_public_path__ + "img/mx.3c009d97.svg";